import { gql } from '@apollo/client';

export const GET_ALL_CATEGORIES = gql`
  query GetAllCategories {
    getAllCategories {
      id
      name
    }
  }
`;

export const GET_ALL_SUB_CATEGORIES = gql`
  query GetAllSubCategories {
    getAllSubCategories {
      id
      name
      categoryId
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_SUB_CATEGORY = gql`
  mutation CreateSubCategory($input: CreateSubCategoryInput!) {
    createSubCategory(input: $input) {
      id
      name
      categoryId
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_SUB_CATEGORY = gql`
  mutation UpdateSubCategory($updateSubCategoryId: ID!, $input: UpdateSubCategoryInput!) {
    updateSubCategory(id: $updateSubCategoryId, input: $input) {
      id
      name
      categoryId
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_SUB_CATEGORY = gql`
  mutation DeleteSubCategory($deleteSubCategoryId: ID!) {
    deleteSubCategory(id: $deleteSubCategoryId)
  }
`;
